/**
 * Impersonation session expiry, read from the `impersonationExpiresAt` custom
 * claim (epoch SECONDS) that startImpersonation sets.
 *
 * firestore.rules and storage.rules stop honouring the grant at this instant,
 * so the client must stop presenting itself as impersonating at the same
 * moment rather than leaving the admin on a firm view whose reads now fail.
 */

/** Expiry in epoch milliseconds, or null when the claim is absent or malformed. */
export function impersonationExpiryMillis(claims: Record<string, unknown>): number | null {
  const value = claims.impersonationExpiresAt;
  return typeof value === 'number' && Number.isFinite(value) ? value * 1000 : null;
}

/**
 * Whether impersonation claims should be treated as ended. A missing expiry
 * counts as expired: the rules fail closed on it, so the client does too.
 */
export function isImpersonationExpired(
  claims: Record<string, unknown>,
  nowMillis: number = Date.now()
): boolean {
  const expiry = impersonationExpiryMillis(claims);
  return expiry === null || nowMillis >= expiry;
}
